import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { LOGO_URL } from "@/lib/api";

const NAV = [
  { to: "/about", label: "About DPO HVAC", testid: "nav-link-about" },
  { to: "/partner", label: "Why Partner With Us", testid: "nav-link-partner" },
  { to: "/join", label: "Why Join Us", testid: "nav-link-join" },
  { to: "/companies", label: "Our Platform Companies", testid: "nav-link-companies" },
  { to: "/contact", label: "Contact", testid: "nav-link-contact" },
];

export function Header() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 bg-white border-b border-slate-200 shadow-[0_1px_12px_rgba(11,25,44,0.04)]" data-testid="site-header">
      <div className="px-4 sm:px-8 lg:px-10 max-w-[1440px] mx-auto flex items-center justify-between gap-6 h-24 lg:h-28">
        <Link to="/" data-testid="nav-logo" className="flex items-center shrink-0">
          <img src={LOGO_URL} alt="DPO HVAC Mechanical Services logo" width="200" height="200" decoding="async" className="h-14 lg:h-[4.5rem] w-auto" />
        </Link>
        <nav className="hidden xl:flex items-center gap-1" aria-label="Primary">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={item.testid}
              className={({ isActive }) =>
                `relative px-4 py-2.5 font-display text-[13px] font-semibold uppercase tracking-[0.08em] transition-colors duration-200 after:absolute after:left-4 after:right-4 after:bottom-1 after:h-0.5 after:rounded-full after:transition-all after:duration-200 ${
                  isActive
                    ? "text-ember after:bg-ember after:opacity-100"
                    : "text-slate-600 hover:text-navy after:bg-ember after:opacity-0 hover:after:opacity-100"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="hidden xl:block shrink-0">
          <Link
            to="/partner"
            data-testid="header-partner-cta"
            className="inline-flex items-center gap-1.5 rounded-full bg-ember px-6 py-3 font-display text-[13px] font-semibold uppercase tracking-[0.08em] text-white transition-colors duration-200 hover:bg-ember-bright"
          >
            Partner With Us <ArrowUpRight className="h-4 w-4" />
          </Link>
        </div>
        <button
          className="xl:hidden text-navy p-2"
          onClick={() => setOpen(!open)}
          aria-label={open ? "Close menu" : "Open menu"}
          data-testid="mobile-menu-toggle"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>
      {open && (
        <nav className="xl:hidden border-t border-slate-200 bg-white px-4 py-4 flex flex-col gap-1" aria-label="Mobile">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={`mobile-${item.testid}`}
              onClick={() => setOpen(false)}
              className={({ isActive }) =>
                `rounded-lg px-4 py-3 font-display text-sm font-semibold uppercase tracking-[0.08em] ${isActive ? "bg-orange-50 text-ember" : "text-slate-600 hover:bg-slate-50"}`
              }
            >
              {item.label}
            </NavLink>
          ))}
          <Link
            to="/partner"
            onClick={() => setOpen(false)}
            data-testid="mobile-header-partner-cta"
            className="mt-2 inline-flex items-center justify-center gap-1.5 rounded-full bg-ember px-5 py-3 font-display text-sm font-semibold uppercase tracking-[0.08em] text-white"
          >
            Partner With Us <ArrowUpRight className="h-4 w-4" />
          </Link>
        </nav>
      )}
    </header>
  );
}
